<!DOCTYPE html>
<div class="sheet-wrapper">
    <!-- Close icon -->
    <div class="close-icon" (click)="closeSlideUp()">
        <img src="../../../assets/images/narrator-tips/close.svg" alt="close icon" />
    </div>
    <!-- Heading -->
    <h2>{{giftCardData?.content?.[selectedLanguage]?.title}}</h2>
    <!-- GIF container -->
    <div class="gif-container">
        <ion-card class="surprisegift-card accordion-card d-flex" [style.background]="giftCardData?.background">
            <div class="winning-gift-detail">
                <div [innerHTML]="currencyValueHtml" class="card-title">
                </div>
                <div class="gift-images">
                    <img src="../../../../assets/icon/sun_rays.svg" alt="timer icon" class="single_sun_rays" />
                    <img [class.custom-promo-icon]="isCredit" [class.custom-promo-game-icon]="isGameIcon"
                        [class.single-icon]="!isCredit && !isGameIcon" [src]="giftCardData?.image_url" />
                </div>
            </div>
        </ion-card>
    </div>

    <!-- Card details -->
    <div class="card-details">
        <!-- Paragraph -->
        <p [innerHTML]="giftCardData?.content?.[selectedLanguage]?.body_description?.[0]"></p>
        <span class="span-para" [innerHTML]="giftCardData?.content?.[selectedLanguage]?.body_description?.[1]"></span>
        <div>
            <span class="para-description"
                [innerHTML]="giftCardData?.content?.[selectedLanguage]?.body_description?.[2]"></span>
            <span class="wishes" [innerHTML]="giftCardData?.content?.[selectedLanguage]?.body_description?.[3]"></span>
        </div>
    </div>
    <!-- Button -->
    <button class="cta-btn"
        (click)="redirectTo(giftCardData?.destination)">{{giftCardData?.content?.[selectedLanguage]?.button_label}}</button>
</div>
